import { render, staticRenderFns } from "./ModalTaskDetail.vue?vue&type=template&id=6fba3c20&scoped=true&lang=pug"
import script from "./ModalTaskDetail.vue?vue&type=script&lang=js"
export * from "./ModalTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalTaskDetail.vue?vue&type=style&index=0&id=6fba3c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba3c20",
  null
  
)

export default component.exports